<template>
  <div
    class="d-flex justify-content-center text-center align-content-center flex-wrap gap-2"
  >
    <div class="visitor-row-wrapper">
      {{ reasonForVisit }}
    </div>
    <i
      v-if="reasonForVisitTooltip"
      :title="reasonForVisitTooltip"
      class="ri-information-line visitor-reason-for-visit-icon"
    />
  </div>
</template>

<script>
import { computed } from "vue"

export default {
  name: "VisitorReasonForVisitColumn",
  props: {
    visitor: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const studentLookUpValues = ["student pick up", "student drop off"]
    const studentLookupMap = {
      "student pick up": "SPU",
      "student drop off": "SDO"
    }

    const isStudentRelated = computed(() => {
      const lookupValue = props?.visitor?.lookup_value?.trim()?.toLowerCase()
      const reasonDescription = props?.visitor?.reason_description
        ?.trim()
        ?.toLowerCase()
      return (
        studentLookUpValues.includes(lookupValue) ||
        studentLookUpValues.includes(reasonDescription)
      )
    })

    const reasonForVisit = computed(() => {
      const lookupValue = props?.visitor?.lookup_value?.trim()?.toLowerCase()
      const reasonDescription = props?.visitor?.reason_description
      const subReasonDescription = props?.visitor?.sub_reason_description

      let values = []
      if (isStudentRelated.value) {
        values = [
          studentLookupMap[lookupValue] || lookupValue,
          subReasonDescription
        ]
      } else {
        values = [subReasonDescription || reasonDescription]
      }
      values = Array.from(new Set(values))
      return values.filter(Boolean).join(" - ")
    })

    const reasonForVisitTooltip = computed(() => {
      const students = props?.visitor?.students?.split("|")?.join(", ") || ""
      return students ? `Student(s): ${students}` : ""
    })

    return {
      reasonForVisit,
      reasonForVisitTooltip
    }
  }
}
</script>

<style scoped></style>
